import React from 'react';
import cn from 'classnames';
import Carousel, {
	ICarouselProps,
	CarouselItem,
} from 'tbk-components/src/components/Carousel';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import BlogRollPostItem, { IBlogRollPostItemProps } from './BlogRollPostItem';

export interface IBlogRollPostsProps extends IBaseElementProps {
	/**
	 * Blog Roll Heading
	 */
	heading?: string;
	/**
	 * Blog Roll Posts
	 */
	posts: IBlogRollPostItemProps[];
	/**
	 * Blog Roll View All Link
	 */
	viewAllLink?: ILink;
}

// TODO: Component currently exposed for Design Review - Remove Block decorator prior to content entry if Blog Roll is integrated with Page Templates, or else B/E will need to implement dynamic selection of posts for use within this component.

/**
 * Blog Roll Posts
 * @block
 * @requiresHooks
 * @icon format-gallery
 */
const BlogRollPosts: React.FC<IBlogRollPostsProps> = ({
	className,
	classNames = [],
	heading,
	posts = [],
	viewAllLink,
}) => {
	if (!Array.isArray(posts)) {
		return null;
	}

	const carouselOptions: any = {};

	if (posts.length <= 3) {
		carouselOptions.swipeThreshold = false;
		carouselOptions.dragThreshold = false;
	}

	return (
		<div
			className={
				className ||
				cn('news-service blogroll-posts-container', ...classNames)
			}
		>
			<div className="blogroll-posts container-fluid">
				<div className="blogroll-posts__header">
					{heading && (
						<h2 className="blogroll-posts__heading">{heading}</h2>
					)}
					{viewAllLink && (
						<Button
							{...viewAllLink}
							className="blogroll-posts__view-all"
						/>
					)}
				</div>
				<div className="blogroll-posts__inner">
					<Carousel
						id="blogroll-posts-carousel"
						className={
							className ||
							cn(
								'blogroll-carousel',
								{
									'hide-desktop-controls': posts.length <= 3,
								},
								...classNames,
							)
						}
						showArrows
						showBullets={false}
						perView={3}
						options={{
							type: 'slider',
							rewind: false,
							focusAt: 0,
							bound: true,
							gap: 26,
							...carouselOptions,
							breakpoints: {
								992: {
									perView: 2,
									swipeThreshold: 80,
									dragThreshold: 120,
								},
								768: {
									perView: 2,
								},
								576: {
									perView: 1,
								},
							},
						}}
					>
						{posts.map((post, index) => (
							<CarouselItem key={index}>
								<BlogRollPostItem {...post} />
							</CarouselItem>
						))}
					</Carousel>
				</div>
			</div>
		</div>
	);
};

export default BlogRollPosts;
